import { render, staticRenderFns } from "./RelationTable.vue?vue&type=template&id=1d0671e6&"
import script from "./RelationTable.vue?vue&type=script&lang=js&"
export * from "./RelationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports